import * as keys from "../enums/QueryKeys";
import useUser from "./useUser";
import {
  BOOKING,
  CLINIC_APPOINTMENTS,
  CLINIC_APPOINTMENTS_TABLE,
  USER_INFINITE_APPOINTMENTS,
} from "../enums/ApiPaths";
import { useFetch, useInfiniteFetch } from "./Fetching";
import dayjs from "dayjs";
import { getDateObject } from "../utils/DateTimeRepository";
import { useSearchParams } from "react-router-dom";
import {
  appointmentParamKeys,
  handlers,
} from "../features/admin/appointments/components/DesktopReservations";
import { useInfiniteQuery } from "@tanstack/react-query";
import axios from "axios";
import { fetch } from "../enums/queryFunction/Fetch";

export default function useGetAppointments() {
  const { roles, currentClinic, profile } = useUser();
  const adminOrEmployee = roles.adminOrEmployee;
  const API_PATH = adminOrEmployee ? CLINIC_APPOINTMENTS : BOOKING;
  const API_ID = adminOrEmployee ? currentClinic?.id : profile?.id;

  const { data, isLoading, error } = useFetch(
    API_PATH,
    API_ID,
    keys.APPOINTMENTS
  );

  return { data, error, isLoading };
}

export function useGetInfiniteAppointments(
  timeFrame,
  path = USER_INFINITE_APPOINTMENTS,
  queryKey = "",
  filters = {}
) {
  const { profile } = useUser();

  return useInfiniteQuery({
    queryKey: queryKey,
    queryFn: async ({ pageParam = 0 }) => {
      const filterParams = new URLSearchParams(filters);
      const filterString = filterParams.toString();
      const filterQuery = filterString ? `&${filterString}` : "";
      const res = await fetch(
        `${path}?page=${pageParam}&size=10&timeFrame=${timeFrame}${filterQuery}`
      );
      return res;
    },

    getNextPageParam: (lastPage) => {
      const nextPage = lastPage?.number + 1;
      return nextPage < lastPage?.totalPages ? nextPage : undefined;
    },

    enabled: !!profile?.id,
  });
}

export function useGetAppointmentsByDate(date, enabled = false) {
  const formattedDate = dayjs(getDateObject(date)).format("YYYY-MM-DD");
  var API_PATH = "/appointments/date/" + formattedDate;

  const { data, isLoading, error } = useFetch(
    API_PATH,
    null,
    keys.PENDING_APPOINTMENTS_CALENDAR + formattedDate,
    Boolean(enabled)
  );

  return { data, error, isLoading };
}

export function useGetTableAppointments() {
  const [searchParams] = useSearchParams();
  const { preferance } = useUser();

  const size = Number(searchParams.get(appointmentParamKeys.tableRow)) || preferance.appointmentTableRowsPerPage || 10;
  const pageNumber =
    Number(searchParams.get(appointmentParamKeys.tablePage)) || 0;
  var from = searchParams.get(appointmentParamKeys.startDate) ?? "";

  var to = searchParams.get(appointmentParamKeys.endDate) ?? "";

  if (String(from) === "Invalid Date") {
    from = "";
  }
  if (String(to) === "Invalid Date") {
    to = "";
  }
  var q = searchParams.get(appointmentParamKeys.search) || "";
  if (String(q) == "null" || String(q).length < 2) {
    q = "";
  }
  const status = searchParams.get(appointmentParamKeys.status) || "";
  let sorterParams = searchParams.get(handlers.orderBy) || "";

  let apiPath = `${CLINIC_APPOINTMENTS_TABLE}?pageNumber=${pageNumber}&size=${size}&from=${from}&to=${to}&q=${encodeURIComponent(q)}&status=${status}&sort=${sorterParams}`;

  const { data, isLoading, error } = useFetch(apiPath, null, [
    keys.APPOINTMENTS_TABLE_KEY,
    size,
    sorterParams,
    pageNumber,
    q,
    to,
    from,
    status,
  ]);

  return { data, error, isLoading, size };
}
